import React from 'react';
import '../App.css';
import { useState, useEffect } from 'react';
import HomeChartData from './Graphs';
import ActivationsChart from './ActivationGraph';
import SubsChart from './SubsChart';
import { hexToBytes } from '@noble/hashes/utils';
import { bech32 } from '@scure/base';
import DefaultAvatar from '../Images/default avatar.svg'

function formatNumberWithCommas(number) {
  return number ? number.toLocaleString() : "0";
}

const npubEncode = (hex) => {
  const Bech32MaxSize = 5000;
  const words = bech32.toWords(hexToBytes(hex));
  return bech32.encode('npub', words, Bech32MaxSize);
};

function HomeData() {
    const [data, setData] = useState(null);
    const [primalAccountBalance, setPrimalAccountBalance] = useState(0);
    const [walletTotalsStrikeAccountBalance, setWalletTotalsStrikeAccountBalance] = useState(0);
    const [avatars, setAvatars] = useState({});
    const [loading, setLoading] = useState(true);
    const [avatarsLoading, setAvatarsLoading] = useState(true);
    const [activeProSubs, setActiveProSubs] = useState(0);
  const [stats, setStats] = useState({ dau: 0, wau: 0, mau: 0, total: 0 });
  const [subscriptionStats, setSubscriptionStats] = useState({
    subscriptions_revenue_usd: "0",
    active_subscriptions: 0,
    active_legend_subscriptions: 0
  });
  const [mediaImportSuccessRatio, setMediaImportSuccessRatio] = useState(0);
  const [mediaImportSuccessCount, setMediaImportSuccessCount] = useState(0);
  const [mediaImportTotalCount, setMediaImportTotalCount] = useState(0);


    useEffect(() => {
      const fetchData = async () => {
        try {
          const signEvent = await window.nostr.signEvent({
            created_at: Math.floor(new Date().getTime() / 1000),
            kind: 10000222,
            tags: [],
            content: 'i want in',
          });

          const fetchHomeData = async (event) => {
            const response = await fetch('https://admin.primal.net/api2', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                event_from_user: event,
                request: ['home', {}],
              }),
            });
            return response.json();
          };

          const fetchWalletTotals = async (event) => {
            const response = await fetch('https://admin.primal.net/api2', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                event_from_user: event,
                request: ['wallet_totals', { kyc_level: 2 , offset: 0, limit: 50 }],
              }),
            });
            return response.json();
          };

          const [homeData, walletTotals] = await Promise.all([
            fetchHomeData(signEvent),
            fetchWalletTotals(signEvent)
          ]);

          if (homeData && !homeData.error) {
            setData(homeData);
            setActiveProSubs(homeData.subscriptions?.active_pro_subscriptions || 0);
             const avail = homeData.high_trust_user_media_metadata_availability || {};
              setMediaImportSuccessRatio(avail.success_ratio ?? 0);
              setMediaImportSuccessCount(avail.success ?? 0);
              setMediaImportTotalCount(avail.total ?? 0);
          } else {
            console.error('Error fetching home data:', homeData.error);
          }

          if (walletTotals && walletTotals.all_primal_wallets_balance !== undefined) {
            setPrimalAccountBalance(walletTotals.all_primal_wallets_balance);
          }

          if (walletTotals && walletTotals.strike_account_balance !== undefined) {
            setWalletTotalsStrikeAccountBalance(walletTotals.strike_account_balance);
          }

          setLoading(false);
        } catch (error) {
          console.error('Error fetching API data:', error);
          setLoading(false);
        }
      };

      fetchData();
    }, []);

    useEffect(() => {
    const fetchProStats = async () => {
      try {
        const e = await window.nostr.signEvent({
          created_at: Math.floor(Date.now() / 1000),
          kind: 10000222,
          tags: [],
          content: 'i want in',
        });
        const res = await fetch('https://admin.primal.net/api2', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ event_from_user: e, request: ['pro_user_stats', {}] }),
        });
        const statsData = await res.json();
        if (statsData && typeof statsData === 'object') {
          setStats({
            dau: statsData.dau,
            wau: statsData.wau,
            mau: statsData.mau,
            total: statsData.total,
          });
        }
      } catch (err) {
        console.error('Error fetching pro_user_stats:', err);
      }
    };
    fetchProStats();
  }, []);

   useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const e = await window.nostr.signEvent({
          created_at: Math.floor(Date.now() / 1000),
          kind: 10000222,
          tags: [],
          content: 'i want in',
        });
        const res = await fetch('https://admin.primal.net/api2', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ event_from_user: e, request: ['subscriptions', {}] }),
        });
        const subsData = await res.json();
        if (subsData && typeof subsData === 'object') {
          setSubscriptionStats({
            subscriptions_revenue_usd: subsData.subscriptions_revenue_usd,
            active_subscriptions: subsData.active_subscriptions,
            active_legend_subscriptions: subsData.active_legend_subscriptions,
          });
        }
      } catch (err) {
        console.error('Error fetching subscriptions:', err);
      }
    };
    fetchSubscriptions();
  }, []);

  // keep your function as-is:
const calculateSubAnnualValue = (activeSubs, activePros) =>
  (activeSubs * 5.5 * 12) + (activePros * 750);

// but call it with activeProSubs instead of the legend count:
const subAnnualValue = calculateSubAnnualValue(
  subscriptionStats.active_subscriptions,
  activeProSubs
);

const formattedSubAnnualValue = formatCurrencyWithoutDecimals(subAnnualValue);

const formattedSuccess = formatNumberWithCommas(mediaImportSuccessCount);
const formattedTarget  = formatNumberWithCommas(mediaImportTotalCount);


    
    function formatCurrencyWithoutDecimals(amount) {
      return `$${Math.round(amount).toLocaleString()}`; // Round and format with commas
    }
  
    if (loading) {
      return <div className="loader"><span></span></div>;
    }
  
    if (!data) {
      return <div>No data available</div>;
    }

    const {
      authenticated,
      authenticated_versions,
      authenticated_users,
      wallet,
      subscriptions,
      dvms
    } = data;

    const numberOfActivatedSubscriptions = subscriptions?.active_subscriptions || 0;
    const numberOfActivatedSubscriptions24h = subscriptions?.new_subscriptions_24h || 0;
    const subRevenue = subscriptions?.subscriptions_revenue_usd || 0;
    const formattedSubRevenue = formatCurrencyWithoutDecimals(subRevenue);
    // Example calculation, adjust as needed

    const androidAppData = authenticated_versions['android'];
    const iOSAppData = authenticated_versions['ios'];
    const webAppData = authenticated_versions['web'];

    const balanceCheck = walletTotalsStrikeAccountBalance - primalAccountBalance;

    function getSubscriptionLabel(months) {
      switch (months) {
        case 1:
          return '1m';
        case 3:
          return '3m';
        case 12:
          return '12m';
        case -1:
          return 'LGD';
        default:
          return ''; // fallback for unexpected values
      }
    }

    return (
      <>
        <div className="Container1">
          <div className="GraphContainerTwo">
            <div className="GroupContainerA">
              <div className="ChartTitleDAUA">Active Subs</div>
              <div className="Group588">
                <p>{formatNumberWithCommas(numberOfActivatedSubscriptions)}</p>
              </div>
            </div>
            <div className="chartplaceA">
              <SubsChart />
            </div>
          </div>
          <div className="GroupContainerOneHome">
            <div className="ContainerOneHome">
              <div className="AuthenticatedHome">
                <div className="GroupContainer">
                  <div className="AuthenticatedHomeTitle">Active Pros</div>
                  <div className="Group408">
                    <p>{formatNumberWithCommas(activeProSubs)}</p>
                  </div>
                </div>
              </div>
              <div className="UniqueIPHome">
                <div className="GroupContainer">
                  <div className="UniqueIPHomeTitle">New Subs 24h</div>
                  <div className="Group410">
                    <p>{formatNumberWithCommas(numberOfActivatedSubscriptions24h)}</p>
                  </div>
                </div>
              </div>
              <div className="NostrUniqueHome">
                <div className="GroupContainer">
                  <div className="NostrUniqueHomeTitle">Studio WAU</div>
                  <div className="Group412">
                    <p>{formatNumberWithCommas(stats.wau)}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="ContainerTwoHome">
              <div className="WebAppDataHome">
                <div className="GroupContainer1">
                  <div className="WebAppHomeTitle2">Sub Annual Value</div>
                  <div className="Group715">
                    <p>{formattedSubAnnualValue}</p>
                  </div>
                </div>
              </div>
              <div className="IOSHome">
                <div className="GroupContainer">
                  <div className="IOSHomeTitle">Studio DAU</div>
                  <div className="Group414">
                    <p>{formatNumberWithCommas(stats.dau)}</p>
                  </div>
                </div>
              </div>
              <div className="AndroidHome">
                <div className="GroupContainer1">
                  <div className="AndroidHomeTitle1">Media Imports 1h</div>
                  <div className="Group714">
                    <p
                      className="MediaPercentage"
                      style={{
                        color: mediaImportSuccessRatio * 100 < 99 ? 'red' : 'green'
                      }}
                    >
                      {(mediaImportSuccessRatio * 100).toFixed(2)}%
                    </p>
                      <p className="balanceCheck">{formattedSuccess} of {formattedTarget}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <div className="Container1">
          <div className="GraphContainerTwo">
            <div className="GroupContainerA">
              <div className="ChartTitleDAUA">Active Wallets</div>
              <div className="Group588">
                <p>{formatNumberWithCommas(wallet.number_of_activated_wallets || 0)}</p>
              </div>
            </div>
            <div className="chartplaceA">
              <ActivationsChart />
            </div>
          </div>
          <div className="GroupContainerOneHome">
            <div className="ContainerOneHome">
              <div className="AuthenticatedHome">
                <div className="GroupContainer">
                  <div className="AuthenticatedHomeTitle">Activations 24h</div>
                  <div className="Group408">
                    <p>{formatNumberWithCommas(wallet.number_of_activated_wallets_24h || 0)}</p>
                  </div>
                </div>
              </div>
              <div className="UniqueIPHome">
                <div className="GroupContainer">
                  <div className="UniqueIPHomeTitle">Transactions 24h</div>
                  <div className="Group410">
                    <p>{formatNumberWithCommas(wallet.number_of_transactions_24h || 0)}</p>
                  </div>
                </div>
              </div>
              <div className="NostrUniqueHome">
                <div className="GroupContainer">
                  <div className="NostrUniqueHomeTitle">Tx Sats 24h</div>
                  <div className="Group412">
                    <p>{formatNumberWithCommas(wallet.transaction_volume_24h * 100000000)}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="ContainerTwoHome">
              <div className="WebAppDataHome">
                <div className="GroupContainer1">
                  <div className="WebAppHomeTitle1">Total Balance</div>
                  <div className="Group714">
                    <p>{wallet.strike_account_balance || 0}</p>
                    <p className={`balanceCheck ${balanceCheck < 0 ? 'negative' : 'positive'}`}>
                      {formatNumberWithCommas(balanceCheck * 100000000)}
                    </p>
                  </div>
                </div>
              </div>
              <div className="IOSHome">
                <div className="GroupContainer">
                  <div className="IOSHomeTitle">Total Transactions</div>
                  <div className="Group414">
                    <p>{formatNumberWithCommas(wallet.number_of_transactions || 0)}</p>
                  </div>
                </div>
              </div>
              <div className="AndroidHome">
                <div className="GroupContainer">
                  <div className="AndroidHomeTitle">Total Tx (BTC)</div>
                  <div className="Group416">
                    <p>{Number(wallet.transaction_volume || 0).toFixed(8)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <div className="Container1">
          <div className="GraphContainerOne">
            <div className="GroupContainer">
              <div className="ChartTitleDAU">Primal DAU</div>
              <div className="Group500">
                <p>{formatNumberWithCommas(authenticated.DAU || 0)}</p>
              </div>
            </div>
            <div className="chartplace">
              <HomeChartData />
            </div>
          </div>
          <div className="GroupContainerOneHome">
            <div className="ContainerOneHome">
              <div className="AuthenticatedHome">
                <div className="GroupContainer">
                  <div className="AuthenticatedHomeTitle">Primal WAU</div>
                  <div className="Group408">
                    <p>{formatNumberWithCommas(authenticated.WAU || 0)}</p>
                  </div>
                </div>
              </div>
              <div className="UniqueIPHome">
                <div className="GroupContainer">
                  <div className="UniqueIPHomeTitle">Primal MAU</div>
                  <div className="Group410">
                    <p>{formatNumberWithCommas(authenticated.MAU || 0)}</p>
                  </div>
                </div>
              </div>
              <div className="NostrUniqueHome">
                <div className="GroupContainer">
                  <div className="AndroidHomeTitle">DVM DAU</div>
                  <div className="Group414">
                    <p>{formatNumberWithCommas(dvms?.per_period?.DAU || 0)}</p>
                  </div>
                  <div className="dvmline"></div>
                </div>
              </div>
            </div>
            <div className="ContainerTwoHome">
              <div className="WebAppDataHome">
                <div className="GroupContainer">
                  <div className="WebAppHomeTitle">Web DAU</div>
                  <div className="Group414">
                    <p>{formatNumberWithCommas(webAppData.DAU || 0)}</p>
                  </div>
                  <div className="webline"></div>
                </div>
              </div>
              <div className="IOSHome">
                <div className="GroupContainer">
                  <div className="IOSHomeTitle">iOS DAU</div>
                  <div className="Group414">
                    <p>{formatNumberWithCommas(iOSAppData.DAU || 0)}</p>
                  </div>
                  <div className="iosline"></div>
                </div>
              </div>
              <div className="AndroidHome">
                <div className="GroupContainer">
                  <div className="AndroidHomeTitle">Android DAU</div>
                  <div className="Group416">
                    <p>{formatNumberWithCommas(androidAppData.DAU || 0)}</p>
                    <div className="androidline"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

const Home = () => {
    return (
        <div className="MainBody">
          <div className="HomeData">
            <HomeData />
          </div>
        </div>
    )
}
 export default Home